import { CustomColumnTypes } from "@/enum/list.enum";

import textIcon from "@/assets/icons/textIcon.svg?url";
import numbersIcon from "@/assets/icons/numbersIcon.svg?url";
import linkIcon from "@/assets/icons/linkIcon.svg?url";
import aiIcon from "@/assets/icons/aiIcon.svg?url";
import checkboxIcon from "@/assets/icons/checkboxIcon.svg?url";
import diceIcon from "@/assets/icons/diceIcon.svg?url";
import googleNewsIcon from "@/assets/icons/googleNewsIcon.svg?url";
import departmentIcon from "@/assets/icons/sidebar/site-map.svg?url";
import toolIcon from "@/assets/icons/sidebar/screw-driver-wrench.svg?url";
import linkedinIcon from "@/assets/icons/linkedin.svg?url";
import jobIcon from "@/assets/icons/job.svg?url";

/** One selectable type in the Add-column modal (label comes from `inbox.<id>` unless overridden). */
export interface CustomColumnTypeItem {
	id: CustomColumnTypes;
	icon: string;
	/** Hardcoded label for types without an `inbox.<id>` translation key. */
	titleOverride?: string;
	/** Shows the "1 credit / row" chip — every enrichment charges per row. */
	usesCredits?: boolean;
}

/** The "Columns" tab: plain, credit-free column types (PREC-3703 modal split). */
export const PLAIN_COLUMN_TYPES: CustomColumnTypeItem[] = [
	{ id: CustomColumnTypes.TEXT, icon: textIcon },
	{ id: CustomColumnTypes.NUMBER, icon: numbersIcon },
	{ id: CustomColumnTypes.LINK, icon: linkIcon },
	{ id: CustomColumnTypes.BOOLEAN, icon: checkboxIcon },
	{ id: CustomColumnTypes.RANDOM_VALUE, icon: diceIcon },
];

/**
 * The "Enrichments" tab: types that derive data (all charge 1 credit per row). DEEP_RESEARCH stays
 * behind its feature flag — the modal filters it out when the flag is inactive.
 */
export const ENRICHMENT_COLUMN_TYPES: CustomColumnTypeItem[] = [
	{ id: CustomColumnTypes.AI_PROMPT, icon: aiIcon, usesCredits: true },
	{ id: CustomColumnTypes.JOB_OFFER, icon: jobIcon, usesCredits: true },
	{ id: CustomColumnTypes.TECHNOLOGY, icon: toolIcon, usesCredits: true },
	{ id: CustomColumnTypes.GOOGLE_NEWS, icon: googleNewsIcon, usesCredits: true },
	{ id: CustomColumnTypes.DEPARTMENT_SIZE, icon: departmentIcon, usesCredits: true },
	{ id: CustomColumnTypes.LINKEDIN_POST, icon: linkedinIcon, usesCredits: true },
	{
		id: CustomColumnTypes.LINKEDIN_POST_ENGAGEMENT,
		icon: linkedinIcon,
		titleOverride: "Analyze Linkedin Post Engagement",
		usesCredits: true,
	},
	{ id: CustomColumnTypes.DEEP_RESEARCH, icon: aiIcon, usesCredits: true },
];
